import { render } from "./DurationFilter.vue?vue&type=template&id=ecf03a50&ts=true"
import script from "./DurationFilter.ts?vue&type=script&lang=ts&external"
export * from "./DurationFilter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__